import type { T } from '../../i18n';
import { Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { Icon } from '../icon';
import { MaterialIcon } from '../icon/icons';
import { CSS } from './stepper.style';

export interface StepperStep {
	label: T;
}

function view(steps: StepperStep[], currentIndex: number): MithrilVNode {
	return m(
		'div',
		{ className: CSS.container },
		steps.flatMap((step, index) => {
			const nodes: MithrilVNode[] = index > 0 ? [m('div', { className: CSS.connector })] : [];
			nodes.push(viewStep(step, index, currentIndex));
			return nodes;
		})
	);
}

function viewStep(step: StepperStep, index: number, currentIndex: number): MithrilVNode {
	const isComplete = index < currentIndex;
	const isUpcoming = index > currentIndex;

	return m('div', { className: CSS.step }, [
		viewBadge(index, isComplete, isUpcoming),
		m('span', { className: `${CSS.label} ${isUpcoming ? CSS.labelUpcoming : ''}` }, Translate(step.label)),
	]);
}

function viewBadge(index: number, isComplete: boolean, isUpcoming: boolean): MithrilVNode {
	if (isComplete) {
		return m('div', { className: `${CSS.badge} ${CSS.badgeComplete}` }, Icon.view(MaterialIcon.CHECK));
	}

	return m('div', { className: `${CSS.badge} ${isUpcoming ? CSS.badgeUpcoming : CSS.badgeCurrent}` }, `${index + 1}`);
}

export const Stepper = { view };
